import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { TruckSupplementaryEquipmentComponent } from './component/supplementary-equipment/truck-supplementary-equipment.component';
import { TruckDetailsDialogComponent } from './component/truck-details-dialog/truck-details-dialog.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    CommonUIModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule
  ],
  declarations: [
    TruckDetailsDialogComponent,
    TruckSupplementaryEquipmentComponent
  ]
})
export class TruckModule { }
